import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { formatScoringStatusText } from '../utils/scoring_status_utils';

// Manager-site scoring status. Renders nothing in the React tree: the
// `.tournaments-status.save_bar` element is Rails-rendered outside the React
// root, so the translated text is written into it directly — the same element
// the legacy globalDynamicUpdate poller used to update. Until the first poll
// resolves (or if translations are unavailable) the server-rendered status
// stays on screen.
const ScoringStatusBar = ({ messages, timeFormat, roundId, scoringStatusUrl, startPolling, stopPolling }) => {
  useEffect(() => {
    if (!scoringStatusUrl || !roundId) return undefined;

    startPolling();
    return () => stopPolling();
    // startPolling/stopPolling are referentially stable: the container's
    // mapDispatchToProps takes no ownProps, so react-redux creates them once
    // per instance — safe to omit from the deps.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scoringStatusUrl, roundId]);

  useEffect(() => {
    if (!messages) return;

    const bar = document.querySelector('.tournaments-status.save_bar');
    const text = formatScoringStatusText(messages, timeFormat);
    if (bar && text) bar.textContent = text;
  }, [messages, timeFormat]);

  return null;
};

ScoringStatusBar.propTypes = {
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      params: PropTypes.object,
    })
  ),
  timeFormat: PropTypes.string,
  roundId: PropTypes.string,
  scoringStatusUrl: PropTypes.string,
  startPolling: PropTypes.func.isRequired,
  stopPolling: PropTypes.func.isRequired,
};

export default ScoringStatusBar;
